module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp12_3016.949fa457.png";